// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"c1cdeebc","498":"4df704bb","598":"73351a75","787":"3ce4cc4d"}[chunkId] + ".chunk.js";
};